var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-600 font-14px card-container p-24",on:{"click":function($event){_vm.isToggleTypeCard && _vm.$emit('toggle')}}},[_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }